<!-- 客户添加 -->
<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      style="margin-top:1vh;"
      width="810px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="title">客户添加</div>
      <div class="table-container">
        <div class="btn-wrap">
          <el-tag
            class="select-stafft-wrap"
            title="选择员工"
            :closable="searchMenNames.length === 0 ? false : true"
            @close="searchCloseTag"
            type="medium"
            effect="plain"
            @click="clickAddMember()"
          >
            <span v-if="searchMenNames.length === 0">选择员工</span>
            <span
              class="staff-names"
              v-for="(item, index) in searchMenNames"
              :key="index"
              >{{ item.name
              }}<span
                v-show="
                  searchMenNames.length > 1 &&
                    index != searchMenNames.length - 1
                "
                >,</span
              ></span
            >
          </el-tag>
          <el-date-picker
            v-model="searchSelectTime"
            size="mini"
            :editable="false"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="selectTime"
            :picker-options="pickerOptions"
            clearable
            style="width: 240px;"
          >
          </el-date-picker>
        </div>
        <div class="table-data">
          <el-table
            v-loading="loading"
            size="medium"
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
            ref="singleTable"
            :highlight-current-row="true"
            :data="staffData"
            height="308px"
            style="width: 100%;height:100%;font-size: 13px"
          >
            <el-table-column
              prop="rowNumb"
              label="客户"
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                <div class="customer">
                  <div class="customer-avatar">
                    <el-avatar
                      size="medium"
                      shape="square"
                      :src="scope.row.avatar"
                    ></el-avatar>
                  </div>
                  <div class="name-wrap">
                    <div class="document-name" v-if="scope.row.ctmName != null">
                      {{ scope.row.ctmName }}
                    </div>
                    <div class="document-name" v-else>--</div>
                    <div class="nickname-wrap">
                      <div
                        class="nickname"
                        :style="scope.row.type == 1 ? '' : 'max-width:5em;'"
                      >
                        {{ scope.row.externalName }}
                      </div>
                      <span
                        style="color: rgb(70, 189, 10)"
                        v-if="scope.row.type == 1"
                      >
                        @微信</span
                      >
                      <span style="color: rgb(8, 168, 231)" v-else>
                        @企业微信</span
                      >
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="客户标签"
              min-width="140"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  <el-popover
                    popper-class="my-popper"
                    placement="top-start"
                    trigger="hover"
                  >
                    <div class="hover-wrap">
                      <div
                        class="wrap-li"
                        v-for="(item, index) in scope.row.tag"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                    <div slot="reference" class="tag-list">
                      <el-tag
                        style="margin:5px 4px 0 0"
                        v-for="(item, index) in scope.row.tag"
                        :key="index"
                        size="small"
                      >
                        <div>{{ item }}</div>
                      </el-tag>
                    </div>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="addWayMean"
              label="添加来源"
              min-width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="添加时间"
              min-width="160"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="userName"
              show-overflow-tooltip
              label="添加员工"
              min-width="118"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :background="true"
          @current-change="callBack"
          :current-page.sync="pageparm.currentPage"
          :page-size="pageparm.pageSize"
          layout="prev, pager, next, jumper"
          :total="pageparm.total"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加人员树 -->
    <!-- <AddMemberView title="选择成员" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='currentSelectMember' @closeTree='closeTree' @clickSubmitTree='clickSubmitTree'></AddMemberView> -->
    <StaffTree
      title="选择成员"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
  </div>
</template>

<script>
import StaffTree from "@/components/staffTree/staffTree.vue";
import { getCusAddDetail } from "@/api/dataStatistics/dataStatistics.js";
import AddMemberView from "@/views/code/components/addMember.vue";
export default {
  name: "addCustomer",
  components: {
    // AddMemberView,
    StaffTree,
  },
  data() {
    return {
      dialogVisibleTree: false,
      currentSelectMember: [], // 当前选中的成员树
      dialogVisible: false,
      searchMenNames: [],
      searchSelectTime: "", // 搜索----选中的时间段
      params: {
        detailStartTime: "",
        detailEndTime: "",
        userIdList: [],
        pageNum: 1,
        pageSize: 10,
      },
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      staffData: [],
      loading: false,
      // 禁选时间
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          const day = 180 * 24 * 3600 * 1000;
          return (
            time.getTime() >
              new Date(new Date().setHours(23, 59, 59, 999)).getTime() -
                8.64e7 || time.getTime() < curDate - day
          );
        },
      },
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
      this.getTableData();
    },
    searchCloseTag() {
      this.searchMenNames = [];
      this.currentSelectMember = [];
      this.params.userIdList = [];
      this.getTableData();
    },
    // 选择时间处理
    selectTime(dataTime) {
      if (dataTime != null) {
        this.params.detailStartTime = dataTime[0];
        this.params.detailEndTime = dataTime[1];
      } else {
        this.params.detailStartTime = "";
        this.params.detailEndTime = "";
      }
      this.params.pageNum = 1;
      this.getTableData();
    },
    callBack(parm) {
      this.params.pageNum = parm;
      this.getTableData();
    },
    // 搜索-添加成员
    clickAddMember() {
      this.dialogVisibleTree = true;
    },
    // 成员树的事件
    clickSubmitTree(val) {
      this.searchMenNames = [];
      this.currentSelectMember = val.currentMember;
      this.dialogVisibleTree = false;
      this.params.userIdList = [];
      val.sendArray.forEach((item) => {
        let obj = {
          userId: item.userId,
          name: item.userName,
        };
        this.searchMenNames.push(obj);
        this.params.userIdList.push(item.userId);
      });
      this.params.pageNum = 1;
      // 发送请求
      this.getTableData();
    },
    // 树关闭
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    // 获取表格数据
    getTableData(isFirst) {
      this.loading = true;
      getCusAddDetail(this.params, localStorage.getItem("Authorization"), true)
        .then((res) => {
          if (res.error.code == 200) {
            this.staffData = res.data.cusAddDetail;
            this.pageparm.total = res.data.total;
            this.loading = false;
          } else {
            this.$message.error("获取表格数据失败，请重试！");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error("获取表格数据失败，请重试！");
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
}
.table-container {
  .btn-wrap {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    /deep/.select-stafft-wrap {
      margin-right: 10px;
      width: 180px;
      position: relative;
      cursor: pointer;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      .el-icon-close {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 5px;
      }
      .staff-names {
        color: #606266;
      }
    }
    /deep/ .el-tag--plain {
      border-color: #dcdfe6;
      color: #c0c4cf;
    }
  }
  .table-data {
    margin-bottom: 16px;
    /deep/.el-table__row .cell {
      padding: 6px 12px;
    }
    /deep/ .el-table--medium td {
      padding: 0;
    }
    .customer {
      display: flex;
      align-items: center;
      .customer-avatar {
        display: flex;
        align-items: center;
        margin-right: 12px;
      }
      .name-wrap {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .document-name {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.9);
          font-weight: 400;
          max-width: 7em;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .nickname-wrap {
          display: flex;
          align-items: center;
          color: #a09f9fc9;
          font-size: 12px;
          .nickname {
            max-width: 7em;
            margin-right: 2px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
        }
      }
    }
    .tag-list {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
// /deep/.el-pagination {
//   .btn-prev,.btn-next {
//     background-color: white;
//     border: 1px solid #E6E9EB;
//   }
//   .el-pager  {
//     li {
//       background-color: white;
//       // border: 1px solid #2684FF;
//       color: rgba(0, 0, 0, 0.6);
//       border: 1px solid #E6E9EB;
//       border-radius: 2px;
//     }
//     li:not(.disabled).active {
//       border: 1px solid #2684FF;
//       color: #2684FF;
//       background-color: white;
//     }
//   }
// }
/deep/ .el-dialog__header {
  padding: 28px 28px 10px 32px;
}
/deep/ .el-dialog__body {
  padding: 14px 32px 6px;
}
/deep/ .el-dialog__footer {
  padding: 4px 32px 32px;
  .el-button {
    width: 88px;
    height: 32px;
    padding: 0;
  }
}
.my-popper {
  .hover-wrap {
    padding: 10px;
    background-color: #1f2329;
    border-radius: 10px;
    color: white;
    .wrap-li {
      text-align: center;
    }
  }
}
</style>
